import "../styles/about4c.css";
import aboutImage from "../assets/about4c.png";   // 👈 IMPORT IMAGE

export default function About4C({ data }) {
  if (!data) return null;

  return (
    <section className="about4c-section reveal">
      <div className="about4c-container">

        {/* TEXT CONTENT */}
        <div className="about4c-content">
          <h2 className="about4c-title">{data.title}</h2>

          <p className="about4c-desc">
            {data.desc1}
          </p>

          <h3 className="about4c-highlight">
            {data.main}
          </h3>

          <p className="about4c-desc">
            {data.desc2}
          </p>
        </div>

        {/* IMAGE */}
        <div className="about4c-image-wrapper">
          <img
            src={aboutImage}   // 👈 USE LOCAL IMAGE
            alt="The 4Cs Framework"
            className="about4c-image"
          />
        </div>

      </div>
    </section>
  );
}
